"use client";

import type { ReactNode } from "react";
import ClerkThemeProvider from "./ClerkThemeProvider";
import {
  ExamSessionProvider,
  type ListExamSessions,
} from "./ExamSessionContext";
import QueryProvider, { type QueryProviderProps } from "./QueryProvider";

export interface GamjaPlatformProvidersProps {
  children: ReactNode;
  afterQuery?: ReactNode;
  /**
   * 회차 목록 조회. 앱별 서버 액션을 주입한다.
   * 공용 패키지가 특정 앱의 서버 액션을 직접 부르면 빌드하는 앱과 무관하게
   * 그 앱의 Firestore 를 읽게 되므로 여기서 받는다.
   */
  listExamSessions?: ListExamSessions;
  /** React Query provider 안쪽을 감싸는 앱별 래퍼(예: JCG 문제 캐시 동기화). */
  queryWrapper?: QueryProviderProps["wrapper"];
  /** React Query provider 하위에 함께 마운트할 노드(예: devtools). */
  queryExtras?: QueryProviderProps["extras"];
}

export function GamjaPlatformProviders({
  children,
  afterQuery,
  listExamSessions,
  queryWrapper,
  queryExtras,
}: GamjaPlatformProvidersProps) {
  return (
    <ClerkThemeProvider>
      <QueryProvider wrapper={queryWrapper} extras={queryExtras}>
        <ExamSessionProvider listExamSessions={listExamSessions}>
          {children}
        </ExamSessionProvider>
      </QueryProvider>
      {afterQuery}
    </ClerkThemeProvider>
  );
}
